import type { Subject } from "../../../../lib/subject-data"
import { SubjectTableRow } from "./subject-table-row"

interface SubjectTableProps {
  subjects: Subject[]
  onEdit: (subject: Subject) => void
  onDelete: (id: string) => void
}

export function SubjectTable({ subjects, onEdit, onDelete }: SubjectTableProps) {
  return (
    <div className="bg-card rounded-xl shadow-lg border border-border overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-muted border-b border-border">
              <th className="p-5 text-sm font-semibold tracking-wide text-muted-foreground uppercase">Subject Name</th>
              <th className="p-5 text-sm font-semibold tracking-wide text-muted-foreground uppercase">Code</th>
              <th className="p-5 text-sm font-semibold tracking-wide text-muted-foreground uppercase">Enrolled</th>
              <th className="p-5 text-sm font-semibold tracking-wide text-muted-foreground uppercase">
                Assigned Teacher
              </th>
              <th className="p-5 text-sm font-semibold tracking-wide text-muted-foreground uppercase text-right">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {subjects.map((subject) => (
              <SubjectTableRow key={subject.id} subject={subject} onEdit={onEdit} onDelete={onDelete} />
            ))}
          </tbody>
        </table>
      </div>
      <div className="px-5 py-4 border-t border-border flex items-center justify-between">
        <p className="text-sm text-muted-foreground">
          Showing 1 to {subjects.length} of {subjects.length} results
        </p>
      </div>
    </div>
  )
}
